// Cart page : Remove the product and redirect to product page on edit button click

let editButton = document.querySelectorAll('.cart .line-item__edit-button');
for (var i = 0; i < editButton.length; i++) {
  editButton[i].addEventListener('click', function (e) {
    e.preventDefault();
    let item = this.closest('.line-item');
    let itemId = item.getAttribute('data-id');
    let itemQuantity = item.getAttribute('data-quantity');
    let itemUrl = item.getAttribute('data-url');
    let formData = {
      'id': itemId,
      'quantity': itemQuantity - 1
    };
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then(response => {
      let productUrl = window.location.origin + itemUrl;
      window.location.replace(productUrl);
    }).catch(error => {
      console.error('Error:', error);
    });
  });
}